import { ElementRef } from '@angular/core';

export const findElementByBlockId = (el: ElementRef, uid: string): { element, blockId } => {
  let doLoop = true;
  let element = el.nativeElement;
  let blockId;
  while (doLoop && element) {
    blockId = element.getAttribute('data-c-id');
    if (blockId === uid) {
      doLoop = false;
    } else {
      element = element.parentNode;
    }
  }
  return {element, blockId};
};

export const findElementByBlockIdRecursiveDown = (element, uid: string): { element, blockId } => {
  const blockId = element.getAttribute('data-c-id');
  if (blockId === uid) {
    return {element, blockId};
  }
  if (element.children) {
    for (const child of element.children) {
      const val = findElementByBlockIdRecursiveDown(child, uid);
      if (val) {
        return val;
      }
    }
  }
  return null;
};
